import _ from 'lodash';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { withFormik } from 'formik';
import { Row, Col, Panel, InputGroup, Nav, NavItem, Well } from 'react-bootstrap';
import ConfirmDialog from './common/ConfirmDialog';
import Button from './common/Button';
import FormEditor, { prepareFieldsForSaving } from './common/FormEditor';
import EditTypesDialog from './common/EditTypesDialog';
import Select from './common/Select';
import FormField from './common/FormField';
import { isEmptyObject } from '../validators/formValidators';
import DynamicFields,
       { getDynamicFieldsMapFromConfig, 
         filterDynamicFieldsMap } from './common/DynamicFields';

import { clientsAllAction,
         clientSavingNeededAction,
         clientsRefreshNeededAction,
         clientEditAction,
         clientNewAction,
         clientEditIdAction,
         clientTypeSet } from '../actions/clientActions';

import { caseClientSetAction,
         caseSetServerError } from '../actions/caseActions';

import { contactFormSaveAction } from '../actions/formActions';
import LoadingProgressBar from './common/LoadingProgressBar';
import { getObjectValue, findBootstrapEnvironment, getTodayDateTZ, replaceFieldsInConfig, getFormEditorSuggestionFieldsArrayFromConfig } from '../helpers/utils';
import { defaultClient, defaultClientType } from '../helpers/config';
import { validateDynamicForm } from './../validators/dynamicFormValidator';
import { onClientFormEditorSave } from './../../client/formEditor';
import { getCountry } from '../helpers/internationalization';


class ClientForm extends PureComponent {
    constructor(props) {
        super(props);
        this.renderFormEditor = this.renderFormEditor.bind(this);
        this.formEditorSave = this.formEditorSave.bind(this);
        this.formEditorCancel = this.formEditorCancel.bind(this);
        this.state = {
            dialogTitle: '',
            dialogText: '',
            dialogCancel: () => {this.setState({dialogOpen: false})},
            dialogConfirm: () => {},
            dialogOpen: false,
            editedClientsDialogOpen: false,
            editedConfig: undefined,
            editedClientType: undefined,
        };
    }


    componentDidMount() {
        switch (this.props.editType) {
        case 'new':
            this.props.dispatch(clientNewAction());
            break;

        case 'edit':
            if (isEmptyObject(this.props.clients.current)) {
                if (!this.props.clients.loadingCurrent) {
                    this.props.dispatch(clientEditIdAction(this.props.params.id))
                        .then((result) => {
                            if (isEmptyObject(result.data)) {
                                this.props.dispatch(clientsAllAction());
                                browserHistory.push('/client/all');
                                return;
                            }

                            this.props.dispatch(clientEditAction(result.data.client));
                        })
                        .catch((error) => {
                            console.error(new Error().stack, error);
                            this.props.dispatch(caseSetServerError(error));
                        });
                }
            }

            break;

        default:
            break;
        }
    }


    componentWillReceiveProps(nextProps) {
        if (this.props.clientType !== nextProps.clientType) {
            nextProps.setFieldValue('ClientType', nextProps.clientType);
        }

        let editedConfig = this.state.editedConfig;
        let editedClientType = this.state.editedClientType;
        if (nextProps.renderFormEditor) {
            if (editedClientType === undefined && nextProps.clientType) {
                editedClientType = nextProps.clientType;
            }

            if (nextProps.currentConfig && !_.isEqual(nextProps.currentConfig, editedConfig)) {
                editedConfig = _.cloneDeep(nextProps.currentConfig);
            }
        }

        this.setState({ editedConfig, editedClientType });
    }

    formEditorSave() {
        const client = this.state.editedConfig.client;
        for (let i = 0; i < client.length; i++) {
            const clientTables = client[i].tables.find(v => v.table === 'client');
            const clientFields = (clientTables && clientTables.fields) || [];
            prepareFieldsForSaving(clientFields);
        }

        onClientFormEditorSave(this.props.dispatch, client, () => this.props.onFormEditorSave());
    }

    formEditorCancel() {
        this.props.onFormEditorCancel();
    }

    renderFormEditor() {
        if (!this.state.editedConfig || !this.state.editedClientType) {
            return (<div />);
        }

        const clientType = this.state.editedClientType;
        const currentConfig = this.state.editedConfig;
        const clientFieldsMap = getFieldsMap(currentConfig, clientType);
        let hasError = false;
        if (clientFieldsMap) {
            hasError = clientFieldsMap.reduce((error, curr) => error || !!curr.error, false);
        }

        let clients;
        let clientTypes;
        let caseTypes;
        if (!isEmptyObject(currentConfig)) {
            clients = currentConfig.client;
            clientTypes = currentConfig.client.map(item => item.type);
            caseTypes = currentConfig.workflow.map(item => item.type);
        }
        
        const isSubmitting = this.props.isSubmitting;

        return (
            <ConfirmDialog
                title="Edit Contact Forms"
                cancel={this.formEditorCancel}
                confirm={this.formEditorSave}
                open={this.props.formEditorOpen}
                disabled={hasError}
            >
            <div style={{ overflowY: 'visible', overflowX: 'hidden' }}>
            <Row>
            </Row>
            <Row>
                <Col xs={12}>
                    <FormField>
                        <InputGroup>
                        <Select field={{
                            onChange: evt => this.setState({ editedClientType: evt.target.value}),
                                    onBlur: () => {},           
                                    value: clientType,
                                }}
                                disabled={typeof(clientTypes) === 'undefined'}
                                loading={typeof(clientTypes) === 'undefined'}
                                options={clientTypes}
                        />
                        <InputGroup.Button style={{paddingTop: "5px"}}>
                        <Button onClick={() => {
                                    this.setState({editedClientsDialogOpen: true});
                                }}
                                disabled={isSubmitting}
                                icon="cog"
                                bsStyle="link"
                                iconStyle={{height: "20px", paddingTop: "2px"}}
                                tooltip="Configure contact types"
                                tooltipPosition="left"/>
                        </InputGroup.Button>
                        </InputGroup>
                    </FormField>
                </Col>
            </Row>
            <Col xs={12}>
            <Well>
            {clientType === 'Client' ? 
                "Edit the fields contained on the form describing type of contact you are working with. Client is a special contact type that all case forms share."
                :
                "Edit the fields contained on the form describing type of contact you are working with. This contact can used in case form via 'Contact' type field."}
            </Well>
            </Col>
            <Row>
            <Col xs={12}><legend>Fields:</legend></Col>
            </Row>
            <Row>
                <Col xs={12}>
                    <FormEditor fields={clientFieldsMap || []}
                                suggestedFields={this.props.clientSuggestionFields}
                                placeholderNamePrefix={''}
                                disallowedPlaceholderNames={['id', 'undefined', 'true', 'false', 'ClientType', 'Referral', 'CreatedDate', 'FirstName', 'LastName', 'MiddleName', 'Phone', 'Email', 'Name', 'ClientManager']}
                                renderSaveButton={false}
                                renderCancelButton={false}
                                disallowedFieldTypes={['Contact']}
                                visibility={clientType === 'Client' ? [...caseTypes] : false}
                                onChange={(fields) => { 
                                    const editedConfig = replaceFieldsInConfig(currentConfig, clientType, 'client', fields, 'client');
                                    this.setState({ editedConfig });
                                }}
                    />
                </Col>
            </Row>
            <EditTypesDialog types={clients}
                                defaultType={defaultClient}
                                open={this.state.editedClientsDialogOpen}
                                onClose={() => {
                                    this.setState({editedClientsDialogOpen: false});
                                }}
                                label='Edit Contact Types'
                                typeLabel='Selected Contact Type'
                                modificationDisabled={(types, selectedIndex) => {
                                    let modificationDisabled = true;
                                    if (selectedIndex >= 0 && this.props.clientStat && types[selectedIndex]) {
                                        let selectedType = types[selectedIndex].type;
                                        if (selectedType === defaultClientType) {
                                            modificationDisabled = true;

                                        } else if (!this.props.clientStat[selectedType] || this.props.clientStat[selectedType] == 0) {
                                            modificationDisabled = false;
                                        }
                                    }

                                    return modificationDisabled;
                                }}
                                saveAction={client => {
                                    const editedConfig = currentConfig;
                                    editedConfig.client = _.cloneDeep(client);
                                    this.setState({editedConfig});
                                }}
            />
            </div>
            </ConfirmDialog>
        );
    }

    render() {
        const {
            headers,
            rows,
            handleSubmit,
            isSubmitting,
            loadingCurrent,
            savingNeeded,
            serverError,
            currentConfig,
            clientType,
            renderFormEditor,
            values,
            submitForm,
        } = this.props;

        if (renderFormEditor) {
            return this.renderFormEditor();
        }

        let initializedRows = [];
        if (rows) {
            initializedRows = rows;
        }

        let clientFieldsMap = this.props.clientFieldsMap;
        let clientTypes = undefined;
        if (!isEmptyObject(currentConfig)) {
            clientTypes = currentConfig.client.map((item) => {
                return item.type;
            });
        }

        const size = findBootstrapEnvironment();
        let hasErrors = false;
        Object.keys(this.props.errors).map(error => {
            hasErrors = hasErrors || this.props.touched[error];
        });

        if (this.props.showAsDialog) {
            return (
            <ConfirmDialog title={this.props.dialogTitle}
                           cancel={this.props.dialogCancel}
                           confirm={this.props.dialogConfirm}
                           error={hasErrors}
                           confirmButton={(
                            <Button bsStyle="primary"
                                    label="Save"
                                    icon="floppy-disk"
                                    loading={isSubmitting}
                                    disabled={isSubmitting}
                                    loadingLabel="Saving..."
                                    onClick={() => {
                                        submitForm();
                                    }}
                            />
                           )}
                           open={this.props.dialogOpen}
                           size={this.props.dialogSize}
            >
            <Row>
                <Col xs={12}>
                    <div>
                        {loadingCurrent && (
                        <Row>
                            <Col xs={12}>
                                <LoadingProgressBar loading={loadingCurrent} />
                            </Col>
                        </Row>)}
                        <Row>
                            <Col xs={12} md={12}>
                                <Select field={{
                                            onChange: evt => this.props.dispatch(clientTypeSet(evt.target.value)),
                                            onBlur: () => {},           
                                            value: clientType,
                                        }}
                                        label='Contact Type'
                                        disabled={typeof(clientTypes) === 'undefined'}
                                        loading={typeof(clientTypes) === 'undefined'}
                                        options={clientTypes}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} md={12}>
                                <DynamicFields
                                    {...this.props}
                                    values={values}
                                    errors={this.props.errors}
                                    touched={this.props.touched}
                                    handleBlur={this.props.handleBlur}
                                    handleChange={this.props.handleChange}
                                    fieldsMap={clientFieldsMap}
                                    submitting={isSubmitting}
                                    loading={loadingCurrent}
                                    currentConfig={currentConfig}
                                    country={getCountry(this.props.loggedIn)}
                                />
                            </Col>
                        </Row>
                    </div>
                </Col>
            </Row>
            </ConfirmDialog>);
        }

        const output = (
            <Row>
                <Col md={6} xs={12} style={{marginLeft: 15}}>
                    <Panel data-hj-whitelist header={clientType}>
                        <Row>
                            <Col xs={12}>
                                <LoadingProgressBar loading={loadingCurrent} />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} md={12}>
                                <Select field={{
                                            onChange: evt => this.props.dispatch(clientTypeSet(evt.target.value)),
                                            onBlur: () => {},           
                                            value: clientType,
                                        }}
                                        label='Contact Type'
                                        disabled={typeof(clientTypes) === 'undefined'}
                                        loading={typeof(clientTypes) === 'undefined'}
                                        options={clientTypes}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} md={12}>
                                <DynamicFields
                                    {...this.props}
                                    values={values}
                                    errors={this.props.errors}
                                    touched={this.props.touched}
                                    handleBlur={this.props.handleBlur}
                                    handleChange={this.props.handleChange}
                                    fieldsMap={clientFieldsMap}
                                    submitting={isSubmitting}
                                    loading={loadingCurrent}
                                    currentConfig={currentConfig}
                                    country={getCountry(this.props.loggedIn)}
                                />
                            </Col>
                        </Row>
                    </Panel>
                </Col>
            </Row>
        );

        return (
            <form onSubmit={handleSubmit}>
                {output}
                <ConfirmDialog
                    title={this.state.dialogTitle}
                    text={this.state.dialogText}
                    cancel={this.state.dialogCancel}
                    confirm={this.state.dialogConfirm}
                    open={this.state.dialogOpen} />
            </form>
        );
    }
}

export const validateClientForm = (data, props) => {
    let errors = {};
    errors = validateDynamicForm(data, filterDynamicFieldsMap(props.clientFieldsMap));
    return errors;
};


const getFieldsMap = (config, clientType) => {
    return getDynamicFieldsMapFromConfig(config, clientType, 'client', false, 'client').filter((field) => {
        return field.type !== 'ClientType';
    });
};

const mapStateToProps = (state, ownProps) => {
    const currentClient = state.clients.current;
    const currentConfig = state.user.config;
    const loggedIn = state.user.loggedIn;
    let clientType;    
    let workflow = [];
    if (currentConfig) {
        workflow = currentConfig.workflow;
    }

    if (currentConfig) {
        const client = currentConfig.client;
        if (currentClient['ClientType'] && client && client.find(v => v.type === currentClient['ClientType'])) {
            clientType = currentClient['ClientType'];
        } else if (client.length > 0) {
            clientType = client[0].type;
        }
    }

    const initialValues = { ...currentClient, id: getObjectValue(currentClient, 'id'), ClientType: clientType };
    if (!initialValues['CreatedDate']) {
        initialValues['CreatedDate'] = getTodayDateTZ(loggedIn, true, true);
    }

    let clientFieldsMap;
    if (clientType) {
        clientFieldsMap = getFieldsMap(currentConfig, clientType);
        for (let i = 0; i < clientFieldsMap.length; i++) {
            if (!initialValues[clientFieldsMap[i].name]) {
                initialValues[clientFieldsMap[i].name] = undefined;
            }
        }
    }

    const clientStat = (state.user.stats && state.user.stats.client) || {};
    const clientSuggestionFields = getFormEditorSuggestionFieldsArrayFromConfig(currentConfig, 'client', false, (type, table, field) => (!table || table === 'client') && (!field || !['Hidden', 'Separator'].includes(field.type)));   
    return {
        serverError: state.cases._serverError,
        loadingCurrent: state.clients.loadingCurrent,
        savingNeeded: state.clients.savingNeeded,
        currentEditedCase: state.cases.current,
        currentClient,
        clientFieldsMap, // for dynamic form validation
        clientSuggestionFields,
        clients: state.clients,
        clientType,
        clientStat,
        workflow,
        currentConfig,
        initialValues,
        tasksToggled: state.user.tasksToggled,
        loggedIn,
    };
};

const handleSubmit = async (client, formikBag) => {
    try {
        const result = await formikBag.props.dispatch(contactFormSaveAction(client));
        const savedClient = result.data.client;
        formikBag.props.dispatch(clientSavingNeededAction(false));
        formikBag.props.dispatch(clientsRefreshNeededAction(true, true));
        if (!isEmptyObject(formikBag.props.currentEditedCase) &&
            (formikBag.props.currentEditedCase &&
                formikBag.props.currentEditedCase.client &&
                formikBag.props.currentEditedCase.client.id === savedClient.id)) {

            formikBag.props.dispatch(caseClientSetAction(savedClient));
        }

        browserHistory.push(`/client/edit/${savedClient.id}`);
        formikBag.props.dispatch(clientEditAction(savedClient));
        if (formikBag.props.dialogConfirm) {
            formikBag.props.dialogConfirm();
        }

    } catch (error) {
        console.error(new Error().stack, error);
        formikBag.props.dispatch(caseSetServerError(error));
    }

    formikBag.setSubmitting(false);
};


const formikWrapper = {
    mapPropsToValues: props => props.initialValues,
    validate: validateClientForm,
    handleSubmit,
    enableReinitialize: true,
};

export default connect(mapStateToProps)(withFormik(formikWrapper)(ClientForm));

export const EditClientForm = connect(mapStateToProps)(withFormik(formikWrapper)(ClientForm));
